export default __webpack_public_path__ + "static/media/story_jumbo.da916164.jpeg";